import { Button, createStyles } from '@mantine/core';

export const mantineTheme = {
    colorScheme: 'dark',
    components: {
        Container: {
          defaultProps: {
            sizes: {
              xxs: 325,
              xs: 540,
              sm: 720,
              md: 960,
              lg: 1140,
              xl: 1320,
              xxl: "100vw"
            },
          },
        },
      },
    activeStyles: { transform: 'scale(0.95)', transition: 'ease-in-out 100ms' }
}

export const useStyles = createStyles((theme) => ({
    heroContainer: {
      height: "100%",
      display: "grid",
      justifyContent: "center",
    //   borderRadius: "0 100vw 0 100vw",  
      alignItems: "center",
      backgroundColor: "#25262B",
      // Media query with value from theme
      [`@media (max-width: ${theme.breakpoints.xl}px)`]: {
        
      },
  
      // Static media query
      [`@media (max-width: ${theme.breakpoints.xxs}px`]: {
        height: 150
      },
    },
    navContainer : {
        display: 'flex',
        placeContent: 'space-between',
        placeItems: "center",
        alignItems: "center",
        height: 100,
        width: "85vw"
    },
    carousel: {
        width: "100%",
        height: "100%",
        maxWidth: 1320,
        margin: "0 auto"
    },
    maxWidth: {
        maxWidth: "100%",
    },
    carouselImage: {
        height: "100%",
        aspectRatio: "16/9",
        backgroundPosition: "center",
    },
    carouselTypography : {
        width: "100%",
        height: "100%",
        opacity: "90%",
        position: "absolute",
        bottom: 0,
        display: "grid", alignItems: "center"
    }
}));
